import React from 'react';
import { Local } from '../../../../assets/img/svg/icons';

const LocalSection: React.FC<{local: string, map: string}> = ({local, map}) => {
    return (
        <section className='py-8'>
            <div className={`bg-[#F1F4FD] pt-10 ${map ? 'pb-[190px]' : 'pb-10'}`}>
                <div className="max-w-screen-lg mx-auto px-4 grid md:grid-cols-2 gap-y-6">
                    <h3 className="flex items-center gap-6 text-2xl font-semibold text-center text-balance justify-self-center">
                        <Local className='fill-main-pink h-7 w-7 object-contain' />
                        Local do Evento
                    </h3>

                    <div className='text-center lg:text-left text-balance'>
                        {local}
                    </div>
                </div>
            </div>

            {map &&
                <div className="max-w-screen-lg mx-auto px-4" id='map'>
                    <div className="w-full" dangerouslySetInnerHTML={{ __html: map }} />
                </div>
            }
        </section>
    );
};

export default LocalSection;